import {Block, Inline, Text} from "slate";
import {Editor} from 'slate-react';


const { Range, List } = require('immutable');

function normalizeNode(node:Block,editor:Editor,next) {
    if((node.object as any)=='text'&&node.text=='')
    {

        let parent=editor.value.document.getParent(node.key);
        if(parent.object=='block'&&parent.text===''&&parent.nodes.last()===node) {
            if(editor.value.document.nodes.size>1) {
                let block = editor.value.document.getNode(parent.key);
                editor.removeNodeByKey(block.key);
            }

        }

    }

    if((node as any).object=='document'&&node.nodes.size==0)
    {
        let paragraph=Block.create({
            type:'paragraph',
            nodes:[Text.create('')] as any
        });
        editor.insertNodeByKey(node.key,0,paragraph);
    }





}


export var FieldPickerTextBoxPlugin= {
    normalizeNode
}